import '../../components/Nav.css';
import '../../components/ImageGallery.js';
import './Detail.css';
import './DetailLight.css';
import $ from 'jquery';
import MetaTags from 'react-helmet';
import React, { Component, useState, useRef, useEffect } from 'react';
import PDFDocument from '../../components/PDFDocument';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import ShareBtn from '../../components/ShareBtn.js';
import { 
  setContext
} from '../../model/recipe/recipeSlice';
import { useDispatch } from 'react-redux';

import HighligthRecipe from '../../components/HighlightRecipe.js';

import { withRouter } from "react-router-dom";
class Detail extends Component {
  preparations = [];
  credits = undefined;
  constructor(props) {
    super(props);
    this.state = {
      showPDF: false,
    };
    this.credits = new URLSearchParams(window.location.search).get("credits");
    this.handlePDFPreview = this.handlePDFPreview.bind(this);
  }
  componentDidUpdate() {
    document.getElementsByTagName("body")[0].scrollTo(0,0);
    resize();
  }
  handlePDFPreview(key) {
    this.setState({
      showPDF: true,
    });
  }
  render() {
    let { name } = this.props;
    const expansionFactor = window.matchMedia('only screen and (max-width: 1000px)').matches ? 2 : 1;
    window.scrollTo(0, 0);
    var rootElement = require("../../json/"+name+".json");
    var imageName = this.credits ? this.credits + "/" + rootElement.image[0] : rootElement.image[0];

    $(function() {
      $(window).on('scroll', function() {
        if ($('.content-wrapper').offset()) {
           
          if($(window).scrollTop() >= $('.content-wrapper').offset().top - 300) {
            $('.nav-bg').removeClass('bg-hidden');
            $('.nav-bg').addClass('bg-visible');
          } else {
            $('.nav-bg').removeClass('bg-visible');
            $('.nav-bg').addClass('bg-hidden');
          }
        }
      });
    });
    window['pdfPreview'] = this.handlePDFPreview;
    var shareStyle = expansionFactor===1? "{\"position\": \"fixed\", \"zIndex\": 10000, \"transform\": \"rotate(270deg)\", \"right\": \"-60px\", \"left\": \"unset\", \"top\": \"50vh\"}":  "{\"position\": \"fixed\", \"zIndex\": 10000, \"transform\": \"rotate(90deg)\", \"left\": \"-130px\", \"top\": \"50vh\"}"
  return([
    <div key={"Detail" + 1}>
    { (this.state.showPDF) ?
      <div key="PDFViewer" id="PDFViewer" onClick={() => {this.setState({showPDF:false})}} className="pdf-viewer-container">
        <PDFViewer className="pdf-viewer">
          <PDFDocument ricetta={rootElement} />
        </ PDFViewer>
        <PDFDownloadLink document={<PDFDocument ricetta={rootElement} />} className="pdf-download btn" fileName={rootElement.title}>
          {({ blob, url, loading, error }) =>
            loading ? 'Loading document...' : 'Download now!'
          }
        </ PDFDownloadLink>
      </ div> : 

      <></>
    }
    </div>,
    <ShareBtn shareUrl={`?detail=` + name} shareTitle={rootElement.title} shareId={name} shareStyle={shareStyle} />,
    <div key={"Detail" + 3} className='detail-container'>
      <div className='detail-container-media' style={{backgroundImage: `url(images/${imageName})`}}>
        <div className="pre-nav">
          <nav className="links">
            <CH />
            <span className="line"></span>
          </nav>
        </div>
        <HighligthRecipe recipe={rootElement} />
        
      </div>
      <DetailAttribute 
        elementTitle={rootElement.title} 
        preparations={rootElement.preparations.map(x=>{
          return x.title;
        })}
        preparationsId={rootElement.preparations.map(x=>{
          return x.id;
        })}
      />
      <div id="detail-description" key="2">
      {
        rootElement.preparations.map((element, j) => 
          <div key={element.id} id={element.id} className="content-wrapper">
            {(element.ingredients !==undefined && element.ingredients.length > 0)? (
              <div key={element.id + '1'} className="ing">
                <h2 key={element.id + '11'} style={{"paddingTop":"30px", "borderTop":"2px solid #fff8"}}>Ingredients</h2>

                <div key={element.id + '12'} id="checklist">
                  <Ingredienti ingredienti={element.ingredients} j={j} />
              </div></div>) : (<></>)
            }
            <div key={"DetailInner" + 1} className="descr">
            <h2 style={{"paddingTop":"30px", "borderTop":"2px solid #fff8"}}>{element.title}</h2>
              {
                element.description.split('.').filter(i => i).map((ele) =>
                <p key={ele}>{ele + "."}</p>
              )}
            </div>
          </div>
      )}
      </div>
      <raga-photo-gallery images={rootElement.image} credits={this.credits} id={rootElement.id} photo-title={rootElement.title} />
    </div>,
    <MetaTags key={"Detail" + 4}>
      <title>C@H - {rootElement.title}</title>
      <meta id="meta-description" property="og:description" content="Cooking at home, homemade recipes to make at home." />
      <meta id="og-title" property="og:title" content={"C@H - " + rootElement.title} />
      <meta id="og-image" property="og:image" content={"https://cookinghome.netsons.org/images/"+ rootElement.image[0]} />
    </MetaTags>  
    ]);

  }

}

export default withRouter(Detail);

const DetailAttribute = (props) => {
  const title= props.elementTitle;
  const preparations = props.preparations
  const preparationsId = props.preparationsId
	return ([
      <div key={"DetailAttribute"}>
        <div
          className="content-wrapper">
          <div className='desc main-list'>
            <h1 className='text-overlay'>{title}</h1>
            {
              preparations.map((element, j) => 
              <h2 key={"DetailAttribute" + j}><a href={'#' + preparationsId[j] }>{element}</a></h2>
            )}
          </div>
        </div>
      </div>
  ])
}


const CH = () => {
  const dispatch = useDispatch();
  return (
    <a href="#" onClick={() => {dispatch(setContext({}));}}>
      Cooking@Home
    </a>
  );
}
const IngredientRow = ({ ele, j, i, onChange }) => {
  const inputRef = useRef(null);
  const mirrorRef = useRef(null);

  const resizeInput = () => {
    if (!inputRef.current || !mirrorRef.current) return;

    const width = mirrorRef.current.offsetWidth + 10;
    inputRef.current.style.width = `${Math.max(width, 34)}px`;
  };

  useEffect(() => {
    resizeInput();
  }, [ele.value]);

  return (
    <>
      <input id={j + "" + i} type="checkbox" name="r" value="1" />

      <label htmlFor={j + "" + i}>
        <div
          style={{ display: "inline-flex" }}
        >
          <input
            ref={inputRef}
            style={{ boxSizing: "content-box" }}
            disabled={!!ele.unitaClass}
            id={"qt" + j + "" + i}
            type="number"
            name={"qt" + j + "" + i}
            value={ele.value}
            onChange={e => onChange(e, ele)}
          />
          <span className='inputSpan'>{ele.unita}</span>
          <span
            ref={mirrorRef}
            style={{
              position: "absolute",
              visibility: "hidden",
              height: 0,
              overflow: "hidden",
              whiteSpace: "pre",
              font: "inherit",
            }}
          >
            {ele.value || " "}
          </span>
        </div>

        <span>{ele.label}</span>
      </label>
    </>
  );
};
const Ingredienti = ({ingredienti, j}) => {
  const mapIngredients = (ingredienti) => {
    return ingredienti.map((element, j) => {
      var qt = element.value.match(/^(-?\d+(?:[.,]\d+)?)\s?([a-zA-Z°%]+)?\s?(.*)$/) || "qb";
      console.log(element, qt);
      var unita = qt.length > 3 ? qt[2] : "qb";
      unita = unita === undefined || unita.length > 3 ? undefined : unita;
      var label = qt.length > 3 ? qt[3] : element.label
      label = label.length === 0 ? qt[2] : label;
      return {
        id: j + '-' + element.id,
        label: label,
        value: qt !== "qb" ? Number(qt[1].replace(",",".")) : "",
        unita: unita,
        unitaClass: qt === "qb" ? "align-unita" : ""
      }
    })
  }

  const fixedIngrRef = useRef(null);

  // inizializzato una sola volta
  if (fixedIngrRef.current === null) {
    fixedIngrRef.current = mapIngredients(ingredienti);
  }

  const fixedIngr = fixedIngrRef.current;
  const [ingredients, setIngredients] = useState([...fixedIngr]);
  const proporzionaIngredienti = (e, ingr) => {
    const filtered = fixedIngr.filter(el => el.id === ingr.id);
    var targetValue = e.target.value.replace(/^0+(?=\d)/, "");
    targetValue = targetValue === "" ? "" : Number(targetValue); 
    var proporzioni = targetValue/filtered[0].value;
    console.log(proporzioni);
    const newIngrs = fixedIngr.map(el => {
      if (proporzioni === 0 || el.value === "") 
        return el;
      return { ...el, value: Math.round(el.value * proporzioni * 100) /100 };
    })
    setIngredients(newIngrs);
  }  
  return (
    <>
    {
      ingredients.map((ele, i) => {
        return(
        
<React.Fragment key={ele.id}>
        <IngredientRow
          ele={ele}
          j={j}
          i={i}
          onChange={proporzionaIngredienti}
        />
      </React.Fragment>

      )}
    )}
    </>
  );
}

const resize = () => {
  var p = document.querySelector('div.detail-container-media');

  p.addEventListener('click', function init() {
      p.removeEventListener('click', init, false);
      p.className = p.className + ' resizable';
      var resizer = document.createElement('div');
      resizer.className = 'resizer';
      p.appendChild(resizer);
      resizer.addEventListener('mousedown', initDrag, false);
  }, false);

  var startX, startWidth;

  function initDrag(e) {
    startX = e.clientX;
    startWidth = parseInt(document.defaultView.getComputedStyle(p).width, 10);
    document.documentElement.addEventListener('mousemove', doDrag, false);
    document.documentElement.addEventListener('mouseup', stopDrag, false);
  }

  function doDrag(e) {
    p.style.width = (startWidth + e.clientX - startX) + 'px';
  }

  function stopDrag(e) {
      document.documentElement.removeEventListener('mousemove', doDrag, false);    document.documentElement.removeEventListener('mouseup', stopDrag, false);
  }

}